// extracted by mini-css-extract-plugin
export default {"heading":"OC-z","signin":"PC-z","signupBtn":"QC-z","disabled":"RC-z"};